import React from 'react';
import { useThemeContext } from '../../contexts/ThemeContext';
import './theme.css'

const ThemeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useThemeContext();

  return (
    <div   
      className="ps-4 py-2 rounded transition-colors w-full"
    >
      {isDark ? (
        <div className="text-dark  w-full flex justify-between items-center">Dark Mode
          <label className="switch">
            <input type="checkbox" checked={isDark} onChange={toggleTheme}/>
              <span className="slider"></span>
          </label>
        </div>
      ) : (
        <div className="text-dark  w-full flex justify-between items-center">Dark Mode
          <label className="switch">
            <input type="checkbox" checked={isDark} onChange={toggleTheme}/>
              <span className="slider"></span>
          </label>
        </div>
      )}
    </div>
  );
};

export default ThemeToggle;
